import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ICadastroEvento } from './types';

export const INITIAL_STATE: ICadastroEvento = {
	status: 0,
	data: null,
	dadosEvento: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ICadastroEvento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRO_EVENTO_REQUEST: {
				draft.dadosEvento = action.payload;
				break;
			}
			case Types.CADASTRO_EVENTO_SUCCESS: {
				draft.status = action.payload.response.status;
				draft.data = action.payload.request;
				break;
			}
			case Types.CADASTRO_EVENTO_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.CADASTRO_EVENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
